export default __webpack_public_path__ + "static/media/part-three-mobile.38ce5a61.svg";